(() => {
  for (const section of document.querySelectorAll('[data-freight-quote-section]')) {
    if (section.dataset.freightInitialized) continue;
    section.dataset.freightInitialized = 'true';
    const products = section.querySelector('[data-freight-products]');
    const links = section.querySelector('[data-freight-product-links]');
    const status = section.querySelector('[data-freight-product-status]');
    if (!products || !links || !status) continue;
    const params = new URLSearchParams(window.location.search);
    const root = (section.dataset.rootUrl || '/').replace(/\/?$/, '/');
    let edited = false;
    products.addEventListener('input', () => { edited = true; });
    const readJson = async path => {
      const response = await fetch(path, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product details unavailable');
      return response.json();
    };
    const prefill = async () => {
      if (params.get('cart') === '1') {
        const cart = await readJson(`${root}cart.js`);
        if (!cart.items?.length) return;
        if (!edited) products.value = cart.items.map(item => `${item.sku || 'SKU unavailable'} × ${item.quantity} — ${item.product_title || item.title}${item.variant_title && item.variant_title !== 'Default Title' ? ` / ${item.variant_title}` : ''}`).join('\n');
        links.value = cart.items.map(item => `${item.sku || item.title}: ${new URL(item.url, location.origin).href}`).join('\n');
        status.textContent = 'Your current cart is included. We will confirm the combined delivery quote before payment.';
        return;
      }
      const handle = params.get('product');
      if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return;
      const product = await readJson(`${root}products/${encodeURIComponent(handle)}.js`);
      const variantId = params.get('variant');
      const variant = product.variants?.find(item => String(item.id) === variantId) || product.variants?.find(item => item.available) || product.variants?.[0];
      if (!variant) throw new Error('Product details unavailable');
      if (!edited) products.value = `${variant.sku || 'SKU unavailable'} × 1 — ${product.title}${variant.title !== 'Default Title' ? ` / ${variant.title}` : ''}`;
      links.value = new URL(`${root}products/${handle}?variant=${variant.id}`, location.origin).href;
      status.textContent = variant.available ? 'Product details added. Add any other items you would like included in your quote.' : 'This item is currently unavailable. We can confirm availability when we reply.';
    };
    prefill().catch(() => { status.textContent = 'Enter the product SKU or paste its link above so we can identify your item.'; });
  }
})();
